<template>
  <div class="center">
    <!-- 返回按键 -->
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 搜索条件 -->
    <div class="waitingcom_title">
      <!-- 表单 -->
      <el-form
        :model="formLabelAlign"
        ref="formLabelAlign"
        label-width="130px"
        :label-position="labelPosition"
      >
        <el-form-item label="考生姓名/账号：">
          <el-input
            v-model.trim="formLabelAlign.userName"
            placeholder="请输入考生姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="科室：">
          <el-select
            v-model="formLabelAlign.departmentName"
            placeholder="请选择科室"
            class="hosname"
            @change="handleQuery()"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, index) in options_ks"
              :key="index"
              :label="item.DepartmentName"
              :value="item.DepartmentID"
              style="width: 200px"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职称：">
          <el-select
            v-model="formLabelAlign.pTitle"
            placeholder="请选择职称"
            class="hosname"
            @change="handleQuery()"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, index) in options_zc"
              :key="index"
              :label="item.PTitle"
              :value="item.PTitle"
              style="width: 200px"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="待审核状态：">
          <el-select
            v-model="formLabelAlign.examine"
            placeholder="请选择审核状态"
            class="hosname"
            @change="handleQuery()"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option
              v-for="(item, index) in examineArr"
              :key="index"
              :label="item.label"
              :value="item.value"
              style="width: 200px"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 搜索按钮 -->
      <div class="query_btn">
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetQuery('formLabelAlign')"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
      </div>
    </div>
    <main>
      <p>当前待审批数量：{{ waitExamine.length }}</p>
      <!-- 表格内容 -->
      <div class="content_table" v-loading="isLoading">
        <el-table
          ref="table"
          :data="getData"
          :cell-class-name="stateColor"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column label="序号" type="index" width="60" align="center"
            ><template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" width="350">
            <template slot-scope="scope">
              <div class="operation_box">
                <el-button
                  v-if="scope.row.Status == 0"
                  type="text"
                  size="small"
                  @click.stop="previewClick(scope.row)"
                  >预览</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="foot_box">
        <div class="foot_pagetions">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            :page-sizes="pagesizesArr"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            class="pagination"
          ></el-pagination>
        </div>
      </div>
    </main>
    <WaitPopup
      ref="waitPopup"
      :filterExamList="filterExamList"
      :waitExamine="waitExamine"
      :getDatalist="getDatalist"
    />
  </div>
</template>

<script>
import { getSectionList, getPTitleList } from "@/services/examManager.js";
import loginvuex from "@/store/index";
import systemclass from "@/api/systemclassification";
import WaitPopup from "../components/waitPopup.vue";
export default {
  data() {
    return {
      labelPosition: "right",
      formLabelAlign: {
        userName: "", // 考生姓名
        departmentName: "", // 科室
        pTitle: "", // 职称
        examine: "-1", // 审核状态
      },
      getDataCondition: {
        userName: "", // 考生姓名
      },
      options_ks: [], // 科室下拉框数组
      options_zc: [], // 职称下拉框数组
      examineArr: [
        {
          label: "未审核",
          value: 0,
        },
        {
          label: "通过",
          value: 1,
        },
        {
          label: "未通过",
          value: 2,
        },
      ],
      getData: [],
      formColumns: [
        {
          prop: "RealName",
          label: "姓名",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室",
        },
        {
          prop: "PTitle",
          label: "职称",
        },
        {
          prop: "Status1",
          label: "当前处理结果",
        },
      ],
      isLoading: false,
      currentPage: 1,
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
      waitExamine: [],
      waitPopup: false,
      rowObj: {},
    };
  },
  props: ["changes"],
  components: {
    WaitPopup,
  },
  activated() {
    this.getDatalist("treat"); // 获取待审批人数
    this.init();
  },
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.changes(0);
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.Status1 === "未审核" && columnIndex === 4) {
        return "gray";
      } else if (row.Status1 === "通过" && columnIndex === 4) {
        return "green";
      } else if (row.Status1 === "未通过" && columnIndex === 4) {
        return "red";
      }
    },
    // 预览
    previewClick(row) {
      this.rowObj = row;
      this.$refs.waitPopup.dialogVisible = true;
      this.$refs.waitPopup.isLoading = true;
      setTimeout(() => {
        this.$refs.waitPopup.getFaceImgUrl(row.UserID, "init");
      }, 500);
    },
    // 搜索
    handleQuery() {
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      this.formLabelAlign.userName = this.formLabelAlign.userName
        ? this.formLabelAlign.userName
        : this.getDataCondition.userName;
      this.getDatalist();
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.eachPageNum = val;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      console.log(`当前页: ${val}`);
      this.loading = true;
      this.getDatalist(); // 重新发起请求
    },
    // 重置
    resetQuery() {
      this.formLabelAlign = {
        userName: "", // 考生姓名
        departmentName: "", // 科室
        pTitle: "", // 职称
        examine: "-1", // 审核状态
      };
      this.getDataCondition.userName = "";
      //   this.$refs.table.clearSelection();
      this.getDatalist();
    },
    // 科室下拉框数据
    async getSectionData() {
      const sectionObj = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await getSectionList(sectionObj);
      if (data.Status === 200) {
        this.options_ks = data.Data;
      }
    },
    // 职称下拉框数据
    async getPTitleData() {
      const sectionObj = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await getPTitleList(sectionObj);
      if (data.Status === 200) {
        this.options_zc = data.Data;
      }
    },
    // 获取列表
    async getDatalist(type) {
      this.isLoading = true;
      const obj = {
        userName: this.formLabelAlign.userName,
        departmentID: this.formLabelAlign.departmentName,
        PTitle: this.formLabelAlign.pTitle,
        status: this.formLabelAlign.examine, // -1全部 0未审核 1 通过 2未通过
        pageIndex: this.currentPage - 1,
        pageShow: this.pageSize,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      if (type) {
        // 获取待审批人数
        obj.status = 0;
        obj.pageShow = 999999;
      }
      const { data } = await systemclass.getWaitList(obj);
      if (data.Status == 200 && type === "treat") {
        this.waitExamine = data.Data.data;
        this.isLoading = false;
      } else if (data.Status == 200) {
        this.getData = data.Data.data.map((item) => {
          if (item.Status == 0) {
            item.Status1 = "未审核";
          } else if (item.Status == 1) {
            item.Status1 = "通过";
          } else if (item.Status == 2) {
            item.Status1 = "未通过";
          }
          return item;
        });
        this.total = data.Data.count;
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      } else {
        this.$message.error(data.Msg);
        this.isLoading = false;
      }
      console.log(data);
    },
    init() {
      this.getSectionData();
      this.getPTitleData();
      this.getDatalist();
    },
    // 成功后从轮播数组里过滤掉当前数据
    filterExamList(id) {
      this.$nextTick(() => {
        this.waitExamine = this.waitExamine.filter((item) => {
          return item.UserID != id;
        });
        if (this.waitExamine.length == 0) {
          this.$refs.waitPopup.dialogVisible = false;
          this.getDatalist("treat");
          this.getDatalist();
        } else {
          this.$refs.waitPopup.getFaceImgUrl(
            this.waitExamine[0].UserID,
            "sieve"
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  //   height: 100%;
  min-height: 80vh;
  width: 100%;
  background-color: rgb(255, 255, 255);
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.flex_box {
  height: 81px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
  padding: 0px 24px;
  // justify-content: space-between;
  // padding-right: 20px;
}
.serchTerms {
  height: 81px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;

  .labelTitle {
    width: 75px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 21px;
    color: #333333;
    // margin-left: 25px;
    margin-right: 5px;
  }

  //@at-root
  .isselectico {
    color: #1890ff;
    cursor: pointer;
    // background-color: #00d254;
  }
}

.query_btn {
  margin: 0;
  display: flex;
  ::v-deep .el-button {
    width: 88px;
    height: 40px;
    margin-left: 36px;
  }
}
.select_box {
  margin-left: 40px;
}
// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    // margin-left: 24px;
    // width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    // ::v-deep .el-form-item__content {
    //   margin-left: 115px !important;
    // }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}
.content_table {
  margin: 24px;
}
main {
  padding: 24px;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table .redtwo .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #aaaaaa !important;
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
}
.operation_box {
  .el-button {
    font-size: 16px;
  }
}
</style>